import IOperationSystems from "@/interfaces/IOperationSystems";
import DesktopApps from "@/libs/desktopApps";
import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";

@Component({
    name: 'ModalDownloadApp',
})
export default class ModalDownloadApp extends Vue {
    @Action private getApp!: (osName: string) => Promise<void>;
    @Getter private getDownloadAppStatus!: () => boolean;

    private operationSystems: IOperationSystems[] = [
        DesktopApps.mac,
        DesktopApps.linux,
        DesktopApps.windows
    ];

    private get showModal() {
        return !this.getDownloadAppStatus();
    }

    private async downloadApp(operationSystem: string): Promise<void> {
        await this.getApp(operationSystem);
    }
}